import { withToken, axiosInstanceV1 } from "@rentablo/api";
import { jwtDecode } from "jwt-decode";
import * as Sentry from "@sentry/browser";
import { User, UserWithType } from "@api/v1/model";

const ROLE_PLUS_USER_ROLE = "ROLE_PLUS_SUBSCRIPTION";
const ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION = "ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION";
const ROLE_PRO_SUBSCRIPTION = "ROLE_PRO_SUBSCRIPTION";

export const loadMyself = async (
  token: string | undefined
): Promise<UserWithType> => {
  const response = await axiosInstanceV1.get<User>(`/users/myself`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  let isUserPlus = false;
  let isUserPro = false;

  try {
    const parsedToken = token ? jwtDecode<{ roles: string[] }>(token) : null;
    isUserPro =
      parsedToken?.roles?.includes(ROLE_FINANZFLUSS_PLUS_SUBSCRIPTION) ||
      parsedToken?.roles?.includes(ROLE_PRO_SUBSCRIPTION) ||
      false;
    isUserPlus = response.data.roles?.includes(ROLE_PLUS_USER_ROLE) || false;
  } catch (e) {
    Sentry.captureException(e);
  }

  const isUserFree = !isUserPro && !isUserPlus;

  return {
    ...response.data,
    isUserPro,
    isUserFree,
    isUserPlus,
  };
};

export const getMyself = withToken(loadMyself);
